import React from 'react';
import PropTypes from 'prop-types';
import { useMutation, useQueryClient } from 'react-query';
import { Form } from 'antd';

import DspxModal from '../../../../../HousingStock/components/common/DspxModal/DspxModal';
import { AdminInfoCreateFieldForm } from '../AdminInfoCreateFieldForm/AdminInfoCreateFieldForm';
import { queryKeys } from '../../queries/queryKeys';
import { fieldNames } from '../../constants';
import { createAdminInfoField } from '../../requests/createAdminInfoField';
import showErrorMessage from '../../../../../../helpers/showErrorMessage';

const AdminInfoCreateFieldModalInner = ({
  form,
  companyId,
  orderNum,
  onCancel,
  onSuccess,
  ...props
}) => {
  const { resetFields, validateFieldsAndScroll } = form;
  const queryClient = useQueryClient();

  const adminInfoCreateFieldMutation = useMutation(
    (values) => createAdminInfoField(values),
    {
      onSuccess: (_, values) => {
        queryClient.invalidateQueries(queryKeys.adminInfo(values.companyId));
        onSuccess();
      },
      onError: (error) => {
        showErrorMessage(error, 'Произошла ошибка при создании поля');
      },
    }
  );

  const handleCancel = () => {
    resetFields();
    onCancel();
  };

  const handleSubmit = () => {
    validateFieldsAndScroll(async (err, fieldValues) => {
      if (err) {
        return;
      }
      const requestBody = {
        Items: [
          {
            Type: fieldValues[fieldNames.type],
            Name: fieldValues[fieldNames.name],
            Value: '',
            OrderNum: orderNum,
          },
        ],
      };
      const values = {
        companyId,
        requestBody,
      };
      await adminInfoCreateFieldMutation.mutateAsync(values);
    });
  };

  return (
    <DspxModal
      title="Введите наименование поля"
      okText="Ок"
      cancelText="Отмена"
      width={651}
      onOk={handleSubmit}
      onCancel={handleCancel}
      cancelButtonProps={{
        disabled: adminInfoCreateFieldMutation.isLoading,
      }}
      confirmLoading={adminInfoCreateFieldMutation.isLoading}
      destroyOnClose
      maskClosable={false}
      {...props}
    >
      <AdminInfoCreateFieldForm form={form} />
    </DspxModal>
  );
};

AdminInfoCreateFieldModalInner.propTypes = {
  form: PropTypes.object.isRequired,
  companyId: PropTypes.number.isRequired,
  orderNum: PropTypes.number.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export const AdminInfoCreateFieldModal = Form.create({
  name: 'admin_info_create_field',
})(AdminInfoCreateFieldModalInner);
